import { Platform } from 'react-native';
export const selectPurchaseUrl = (purchaseable) => {
    if (purchaseable.purchaseUrl) {
        return {
            allowPurchaseWithoutAuthentication: false,
            purchaseUrl: purchaseable.purchaseUrl,
        };
    }
    let lastUrl = undefined;
    let lastAllowPurchaseWithoutAuthentication = false;
    for (const eid of (purchaseable?.externalIdentifiers || [])) {
        if (Platform.OS === 'web' &&
            eid.store === 'stripe' &&
            eid.purchaseUrl) {
            return {
                allowPurchaseWithoutAuthentication: eid.allowPurchaseWithoutAuthentication,
                purchaseUrl: eid.purchaseUrl,
            };
        }
        else if (eid.purchaseUrl) {
            lastUrl = eid.purchaseUrl;
            lastAllowPurchaseWithoutAuthentication = eid.allowPurchaseWithoutAuthentication;
        }
    }
    return {
        allowPurchaseWithoutAuthentication: lastAllowPurchaseWithoutAuthentication,
        purchaseUrl: lastUrl,
    };
};
//# sourceMappingURL=selectPurchaseUrl.js.map